<template>
  <section>

    <!-- Re-stocks sections start -->
    <modal-restock v-if="isRestockModal" />
    <modal-validate-restock
      v-if="isRestockValidateModal"
      :products="products"
    />
    <adjustments-modal
      ref="adjustmentsModal"
      v-if="isAdjustmentModal"
      :adjustment-body="adjustment"
    />
    <!-- Re-stocks sections end -->

  </section>
</template>

<script>
import ModalRestock from "./restock/ModalRestock";
import ModalValidateRestock from "./restock/ModalValidateRestock";
import AdjustmentsModal from "./restock/AdjustmentsModal";

export default {
  name: "ModalContent",
  components: {
    ModalRestock,
    ModalValidateRestock,
    AdjustmentsModal,
  },
  data() {
    return {
      isRestockModal: false,
      isRestockValidateModal: false,
      isAdjustmentModal: false,
      adjustment: {},
      products: []
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalContent.vue